var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpectedAmber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.03833,
    y: 1.45789,
    width: 16,
    height: 12.0812,
    fill: "white",
    stroke: "#4F4F4F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8404 12.6029L11.0614 9.71509L9.49566 6.24399L11.4847 5.18475L15.9836 8.97131L16.5894 12.7494L13.8404 12.6029Z",
    fill: "#FFC107",
    stroke: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37307 7.57826L9.43271 5.5234L8.5622 2.4577L5.81909 2.09495L2.26079 3.97687L5.37307 7.57826Z",
    fill: "#FFC107",
    stroke: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96994 12.7963L3.63337 12.605L1.46134 7.61111L5.04195 7.04559L9.66085 8.71617L8.96994 12.7963Z",
    fill: "#FFC107",
    stroke: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4286 8.85992L9.21556 5.28199L6.58991 6.53062L6.41364 9.12572L8.43209 13.1825L11.2637 13.0677L12.4286 8.85992Z",
    fill: "#FFC107",
    stroke: "#4F4F4F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectedAmber);
export default __webpack_public_path__ + "static/media/expected-amber.a7d2b4851254d0e1dc927b6eabc93303.svg";
export { ForwardRef as ReactComponent };